module.exports = __webpack_public_path__ + "img/select.632ecfed.svg";